import React, { FC, useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import CatalogService from "@/services/catalogService";
import { useCountryId } from "@/hooks";
import { DEFAULT_STORE_ID } from "@/constants";
import { BannerRow, Content } from "@/routes/catalogPage/types";
import DynamicBannersWrapper from "../dynamicBanner";

const URL_CONTENT_SOURCES = {
  PAGES: "pages"
};

const DynamicUrlContentLoader: FC<{
  content: BannerRow;
  language: string;
  bannerPageTitle: string;
}> = ({ content, language, bannerPageTitle }) => {
  const countryId = useCountryId();
  const [sections, setSections] = useState<Content[]>([]);

  const { contentSource, url } =
    content?.urlContentLoaderData?.[language] || {};

  useEffect(() => {
    if (!url || contentSource !== URL_CONTENT_SOURCES.PAGES) return;

    let isMounted = true;

    CatalogService.getPageData({
      url,
      countryId,
      language,
      storeId: DEFAULT_STORE_ID
    })
      .then(pageData => {
        if (isMounted) setSections(pageData?.data?.content || []);
      })
      .catch(() => {
        if (isMounted) setSections([]);
      });

    return () => {
      isMounted = false;
    };
  }, [url, contentSource, countryId, language]);

  if (!sections.length) return null;

  return (
    <>
      {sections.map((section, index) => (
        <ErrorBoundary fallback={null} key={section.id || index}>
          <DynamicBannersWrapper
            section={section}
            bannerPageTitle={bannerPageTitle}
          />
        </ErrorBoundary>
      ))}
    </>
  );
};

export default DynamicUrlContentLoader;
